import { render, staticRenderFns } from "./PDPSectionTabs.vue?vue&type=template&id=8efe257e&scoped=true&"
import script from "./PDPSectionTabs.vue?vue&type=script&lang=js&"
export * from "./PDPSectionTabs.vue?vue&type=script&lang=js&"
import style0 from "./PDPSectionTabs.vue?vue&type=style&index=0&id=8efe257e&prod&lang=css&"
import style1 from "./PDPSectionTabs.vue?vue&type=style&index=1&id=8efe257e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efe257e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
